import React, { type JSX } from "react";
import {Button} from "@mui/material";
import {hasAdminAccess, isLoggedIn} from "../../../util/AccountUtils";
import {Account} from "../../../types/Account";

interface BookSpaceButtonProps {
  handleBookingSpace: () => void;
  user: Account | null | undefined;
  formIsValid: boolean;
  instantApproval: boolean;
  isBrokeredBooking: boolean;
}

const BookSpaceButton = (props: BookSpaceButtonProps): JSX.Element => {
  const {handleBookingSpace, user, formIsValid, instantApproval, isBrokeredBooking} = props;
  const isUserAdminAndNotBrokered = !isBrokeredBooking && hasAdminAccess(user);
  const isLoggedInAndFormIsNotValid = isLoggedIn(user) && !formIsValid;
  const shouldDisableButton = isLoggedInAndFormIsNotValid || isUserAdminAndNotBrokered;

  let buttonLabel = 'Log in to Book Space';
  if (isLoggedIn(user)) {
    buttonLabel = instantApproval ? 'Book Space' : 'Request Space';
  }

  return (
    <Button
      className='ss-booking-button'
      variant="contained"
      color="primary"
      onClick={handleBookingSpace}
      disabled={shouldDisableButton}
    >
      {buttonLabel}
    </Button>
  )
}

export default BookSpaceButton;
